"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailValidate = emailValidate;

function emailValidate(email) {
  var emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // eslint-disable-line no-useless-escape

  return emailRegex.test(email);
}